import  VueRouter from 'vue-router';
import  Vue from 'vue';
import  home from '../views/home/index.vue';
import  team from '../views/team/index.vue';
import  teamCheck from '../views/teamCheck/index.vue';
import  person from '../views/person/index.vue';

Vue.use(VueRouter);

const routes=[
    {
        path: '/',
        redirect: '/team'// team是web端团体报名  person是web端个人报名  home是web端主页
    },
    {
        path: '/home',
        name: 'home',
        component: home,
        children: []
    },
    {
        name: 'person',
        path:"/person",
        component:person,
        children: []
    },
    {
        name: 'team',
        path:"/team",
        component:team,
        children: []
    },
    {
        name: 'teamCheck',
        path:"/teamCheck",
        component:teamCheck,
        children: []
    }
   /* {
        path:"/home",
        component:home
    },*/

]

const  router= new VueRouter({
    routes
});

export  default  router



// WEBPACK FOOTER //
// ./src/router/index.js